import { useContext } from 'react';
import styled from 'styled-components';
import { GarmentDto, LookDto } from '../../api/types/LookDtos';
import Garment from '../Garment';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { SelectedGarmentContext } from '../../context/SelectedGarmentContext';
import { SelectedGarmentContextType } from '../../context/types/SelectedGarmentContentType';
import { GarmentsHorizontalScrollContext } from '../../context/GarmentsHorizontalScrollContext';
import { GarmentsHorizontalScrollContextType } from '../../context/types/GarmentsHorizontalScrollContextType';
import GarmentDetails from '../GarmentDetails';
import {
  GARMENTS_IN_LOOK_PREVIEW_FOR_PC,
  GARMENTS_IN_LOOK_PREVIEW_FOR_PC_S,
  GARMENTS_IN_LOOK_PREVIEW_FOR_TABLETS,
  MIN_PC_BODY_WIDTH,
  MIN_PC_S_BODY_WIDTH,
  MIN_TABLET_BODY_WIDTH,
} from '../../constants/StylistConstants';

const Look = (look: LookDto) => {
  const garments: GarmentDto[] = look.look;
  const { selectedGarmentId, saveSelectedGarmentId } = useContext(
    SelectedGarmentContext,
  ) as SelectedGarmentContextType;
  const { scrollSize, saveScrollSize } = useContext(
    GarmentsHorizontalScrollContext,
  ) as GarmentsHorizontalScrollContextType;

  const garmentsToShow =
    window.innerWidth < MIN_PC_S_BODY_WIDTH
      ? GARMENTS_IN_LOOK_PREVIEW_FOR_TABLETS
      : window.innerWidth < MIN_PC_BODY_WIDTH
      ? GARMENTS_IN_LOOK_PREVIEW_FOR_PC_S
      : GARMENTS_IN_LOOK_PREVIEW_FOR_PC;

  const mobileDisplay: boolean = window.innerWidth < MIN_PC_S_BODY_WIDTH;

  const nextGarment = (index: number) => {
    saveSelectedGarmentId(index);
  };

  const handleClick = (direction: string) => {
    if (direction === 'forward') {
      saveScrollSize(scrollSize + 1);
    } else {
      saveScrollSize(scrollSize - 1);
    }
  };

  return (
    <Container>
      <LookWrapper>
        {scrollSize !== 0 && !mobileDisplay ? (
          <ArrowBackWrapper onClick={() => handleClick('back')}>
            <ArrowBackIosIcon fontSize={mobileDisplay ? 'medium' : 'large'} />
          </ArrowBackWrapper>
        ) : (
          <></>
        )}
        {garments.map((garment, index) => (
          <GarmentWrapper
            firstGarmentId={scrollSize}
            onClick={() => nextGarment(index)}
            key={garment.id}
          >
            <Garment
              garment={garment}
              active={index === selectedGarmentId}
              id={index}
            />
          </GarmentWrapper>
        ))}
        {garments.length - scrollSize > garmentsToShow && !mobileDisplay ? (
          <ArrowForwardWrapper onClick={() => handleClick('forward')}>
            <ArrowForwardIosIcon
              fontSize={mobileDisplay ? 'medium' : 'large'}
            />
          </ArrowForwardWrapper>
        ) : (
          <></>
        )}
      </LookWrapper>
      <GarmentDetailsWrapper>
        <GarmentDetails garment={garments[selectedGarmentId]} />
      </GarmentDetailsWrapper>
    </Container>
  );
};

const Container = styled.div``;

const GarmentWrapper = styled.div<{ firstGarmentId: number }>`
  display: flex;
  width: 310px;
  padding-right: 24px;
  transform: translateX(${(props) => -props.firstGarmentId * 334}px);

  @media (max-width: ${MIN_PC_BODY_WIDTH - 1}px) {
    width: 295px;
    transform: translateX(${(props) => -props.firstGarmentId * 319}px);
  }

  @media (max-width: ${MIN_PC_S_BODY_WIDTH - 1}px) {
    padding-right: 15px;
    width: 285px;
  }

  @media (max-width: ${MIN_TABLET_BODY_WIDTH - 1}px) {
    width: 145px;
    padding-right: 15px;
    transform: translateX(${(props) => -props.firstGarmentId * 169}px);
  }
`;

const LookWrapper = styled.div`
  display: -webkit-box;
  justify-content: center;
  position: relative;
  flex-direction: row;
  overflow: hidden;
  border-bottom: 1px solid #b4b4b4;

  @media (max-width: ${MIN_PC_S_BODY_WIDTH - 1}px) {
    overflow-x: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
    ::-webkit-scrollbar {
      display: none;
    }
  }
`;

const GarmentDetailsWrapper = styled.div`
  flex-grow: 1;
  overflow: hidden;
  padding-top: 20px;
`;

const ArrowBackWrapper = styled.div`
  position: absolute;
  left: 0;
  display: flex;
  align-items: center;
  width: 24px;
  height: 385px;
  z-index: 2;
  cursor: pointer;

  @media (max-width: ${MIN_PC_BODY_WIDTH - 1}px) {
    height: 368px;
  }

  @media (max-width: ${MIN_TABLET_BODY_WIDTH - 1}px) {
    height: 190px;
    width: 12px;
  }
`;

const ArrowForwardWrapper = styled.div`
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 385px;
  z-index: 2;
  cursor: pointer;

  @media (max-width: ${MIN_PC_BODY_WIDTH - 1}px) {
    height: 368px;
  }

  @media (max-width: ${MIN_TABLET_BODY_WIDTH - 1}px) {
    height: 190px;
    width: 12px;
  }
`;

export default Look;
